import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";

const SCALE_BIG = new PIXI.Point(2, 2);
const SCALE_SMALL = new PIXI.Point(2, 2);
const BLEND_MODE = PIXI.BLEND_MODES.NORMAL;

export default class SpotlightFactory {
    /** Heads up, the starting alpha is zero */
    public static MakeSpotlight(
        pColor: number = 0xFFFFFF,
        pRotation: number = 0,
        pSmall: boolean = false,
    ): PIXI.Sprite {
        const suffix = pSmall ? "small" : "big";
        const spriteName = "spotlight-" + suffix;
        const scale = pSmall ? SCALE_SMALL : SCALE_BIG;

        const spotlight = HLF.PixiUtils.makeSprite(spriteName, Constants.SPRITESHEET_GAME);

        spotlight.tint = pColor;
        spotlight.blendMode = BLEND_MODE;
        spotlight.alpha = 0;

        spotlight.anchor.set(0.5, 0);
        spotlight.scale.copy(scale);
        spotlight.position.y = -spotlight.height * 0.8;

        spotlight.rotation = PIXI.DEG_TO_RAD * pRotation;

        return spotlight;
    }
}
